import { render } from "./IllustrationOne.vue?vue&type=template&id=5a4937a3&scoped=true"
import script from "./IllustrationOne.vue?vue&type=script&lang=js"
export * from "./IllustrationOne.vue?vue&type=script&lang=js"

import "./IllustrationOne.vue?vue&type=style&index=0&id=5a4937a3&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4937a3"]])

export default __exports__